module.exports = __webpack_public_path__ + "static/staff-john-2-b92a66dd58908ca12afeecd051546cdd.png";